
import { accountService } from "../components/services/account/AccountService";
import { useState, useEffect } from "react";
import './Dashboard.css'


// function: ParseJwt (decoder for jwt token)
function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

function Dashboard() {

  // Usestate : Check of username authenticated
  const [usernameAuthenticated, setUsernameAuthenticated] = useState("");
  const [firstNameAuthenticated, setFirstNameAuthenticated] = useState("");
  const [lastNameAuthenticated, setlastNameAuthenticated] = useState("");
  const [emailAdressAuthenticated, setEmailAdressAuthenticated] = useState("");
  const [selectedCompaniesAuthenticated, setSelectedCompaniesAuthenticated] = useState([]);
  const [selectedCompaniesNameAuthenticated, setSelectedCompaniesNameAuthenticated] = useState([]);

  // Function: Fetch Username from token
  const fetchUsername = async () => {
    const token = sessionStorage.getItem('accessToken');
    const decodedToken = parseJwt(token);
    console.log(decodedToken)
    const username = decodedToken.sub
    setUsernameAuthenticated(username)
  };

  // Function: Fetch Firstname and Last name from backend

  const userInformationRetrieve = async () => {

    // await fetchUsername();

    let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_USERNAME_ENDPOINT}`;

    try {
      //   const params = new URLSearchParams();
      //   params.append('username', usernameAuthenticated);

      const response = await fetch(wsUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
        },

        body: JSON.stringify({ username: usernameAuthenticated })
      });

      if (response.status == 200) {
        let data = await response.json();
        console.log("response data : " + JSON.stringify(data));

        let firstName = data.first_name;
        let lastName = data.last_name;
        let emailAdress = data.email_address;
        let selectedCompanies = data.selectedCompanies;
        setFirstNameAuthenticated(firstName)
        setlastNameAuthenticated(lastName)
        setEmailAdressAuthenticated(emailAdress)
        setSelectedCompaniesAuthenticated(selectedCompanies)

      } else {
        let text = await response.text();
        console.log("error response text : " + text);
      }
    } catch (ex) {
      console.log("ex : " + ex);

    }

  };


  // Function: Fetch CompaniesData from backend

  const companiesDataRetrieve = async () => {

    // await userInformationRetrieve()

    let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_SIRET_ENDPOINT}`;

    for (let siretNumber of selectedCompaniesAuthenticated) {


      try {


        const response = await fetch(wsUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
          },

          body: JSON.stringify({ siretNumber })
        });

        if (response.status == 200) {
          let data = await response.json();
          console.log("response data : " + JSON.stringify(data));
          let creationDate = data[0].creationDate;
          let name = data[0].name;
          let siretNumber = data[0].siretNumber;
          let sirenNumber = data[0].sirenNumber;
          let adress = data[0].address;
          let postCode = data[0].postCode;

          setSelectedCompaniesNameAuthenticated(prevState => [
            ...prevState,
            {
              name,
              creationDate,
              siretNumber,
              sirenNumber,
              adress,
              postCode
            }
          ])


        } else {
          let text = await response.text();
          console.log("error response text : " + text);
        }
      } catch (ex) {
        console.log("ex : " + ex);

      }
    }
  };




  // UseEffect: Retrieve token, decode token and retrieve username
  useEffect(() => {
    // Execution functions
    fetchUsername();

  }, []);


  // UseEffect: Call userInformationRetrieve whenever usernameAuthenticated changes
  useEffect(() => {
    if (usernameAuthenticated) {
      userInformationRetrieve();

    }
  }, [usernameAuthenticated]);

  // UseEffect: Call companiesDataRetrieve whenever selectCompaniesAuthenticated changes
  useEffect(() => {
    if (selectedCompaniesAuthenticated && selectedCompaniesAuthenticated.length > 0) {
      companiesDataRetrieve();
    }
  }, [selectedCompaniesAuthenticated]);


  // Function: Delete selected Companies

  const deleteSelectedCompanies = async (siretNumber) => {

    const selectedItems = [];
    selectedItems.push(siretNumber);


    let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_COMPANY_DELETE_ENDPOINT}`;

    try {
      //   const params = new URLSearchParams();
      //   params.append('username', usernameAuthenticated);

      const response = await fetch(wsUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
        },

        body: JSON.stringify({
          username: usernameAuthenticated,
          selectedCompanies: selectedItems
        })
      });


      if (response.status == 200) {
        console.log("Suppression company de la BDD : ");
        window.location.reload();

      } else {
        let text = await response.text();
        console.log("error response text : " + text);
      }
    } catch (ex) {
      console.log("ex : " + ex);

    }

  };

  // Click event handler for the save button
  const handleDeleteButtonClick = async (siretNumber) => {


    deleteSelectedCompanies(siretNumber);

  };

  return (
    <div className="dashboard-wrapper">
      <h1>Dashboard</h1>
      <h2>Account Information</h2>

      <table className="info-table">
        <tbody>
          <tr>
            <th>Username</th>
            <th>First name</th>
            <th>Last name</th>
            <th>Email Address</th>
          </tr>
          <tr>
            <td>{usernameAuthenticated}</td>
            <td>{firstNameAuthenticated}</td>
            <td>{lastNameAuthenticated}</td>
            <td>{emailAdressAuthenticated}</td>
          </tr>

        </tbody>
      </table>

      <h2>Companies Selection</h2>

      <table className="company-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Date de création</th>
            <th>Numéro SIRET</th>
            <th>Numéro SIREN</th>
            <th>Adresse</th>
            <th>Code postal</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {selectedCompaniesNameAuthenticated.map((company, index) => (
            <tr key={index}>
              <td>{company.name}</td>
              <td>{new Date(company.creationDate).toLocaleDateString()}</td>
              <td>{company.siretNumber}</td>
              <td>{company.sirenNumber}</td>
              <td>{company.adress}</td>
              <td>{company.postCode}</td>
              <td><button className="deleteButton" onClick={() => handleDeleteButtonClick(company.siretNumber)}>delete</button></td>

            </tr>
          ))}
        </tbody>
      </table>



    </div>


  );
}

export default Dashboard;